var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linked-in-logo"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn-logo",
    transform: "translate(7.000000, 7.000000)",
    fill: "#CC0000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2000001,0 L1.8,0 C0.809999975,0 0,0.809999975 0,1.8 L0,16.2000001 C0,17.19 0.809999975,18 1.8,18 L16.2000001,18 C17.19,18 18,17.19 18,16.2000001 L18,1.8 C18,0.809999975 17.19,0 16.2000001,0 Z M5.4,15.3000001 L2.69999997,15.3000001 L2.69999997,7.19999978 L5.4,7.19999978 L5.4,15.3000001 Z M4.04999999,5.66999982 C3.15000001,5.66999982 2.42999998,4.95000001 2.42999998,4.04999999 C2.42999998,3.15000001 3.15000001,2.42999998 4.04999999,2.42999998 C4.95000001,2.42999998 5.66999982,3.15000001 5.66999982,4.04999999 C5.66999982,4.95000001 4.95000001,5.66999982 4.04999999,5.66999982 Z M15.3000001,15.3000001 L12.6000002,15.3000001 L12.6000002,10.5300002 C12.6000002,9.81003513 11.9700002,9.18000028 11.2500002,9.18000028 C10.5300002,9.18000028 9.90000025,9.81003513 9.90000025,10.5300002 L9.90000025,15.3000001 L7.19999978,15.3000001 L7.19999978,7.19999978 L9.90000025,7.19999978 L9.90000025,8.27999974 C10.3500002,7.55999976 11.3400002,7.01999978 12.1500002,7.01999978 C13.8600001,7.01999978 15.3000001,8.45999974 15.3000001,10.1700002 L15.3000001,15.3000001 Z",
    id: "linked-in-fill"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkinLogo);
export default __webpack_public_path__ + "static/media/linkin_logo.92a9612d737c6785d95632e0bf7eb38a.svg";
export { ForwardRef as ReactComponent };